import { css } from '@emotion/core';
import MediaQueries from '../../../../../styles/Grid/MediaQueries';

export const containerCss = css({
  width: '100%',
  position: 'absolute',
  display: 'flex',
  flexWrap: 'wrap',
});

export const containerImageRightBeforeComponentCss = css({
  minHeight: 287,
});

export const containerImageLeftCss = css({
  minHeight: 244,
  position: 'absolute',
  width: '100%',
});

export const imageLeftTopCss = css({
  height: 244,
  position: 'absolute',
  right: 0,
  width: 367,
});

export const imageLeftBottomCss = css({
  height: 287,
  position: 'absolute',
  right: 0,
  width: 441,
});

export const imageRightTopCss = css({
  height: 344,
  width: 480,
  position: 'absolute',
  top: 0,
  left: 0,
});

export const imageRightBottomCss = css({
  height: 256,
  width: 256,
});

export const containerImageRightCss = css({
  minHeight: 226,
  width: '100%',
  [MediaQueries.xl]: {
    minHeight: 256,
  },
});

export const containerImageLeftNextComponent = css({
  minHeight: 344,
  overflow: 'visible',
  position: 'absolute',
  width: '100%',
});

export const bleedImageLeftCss = css({
  minHeight: 188,
  marginTop: 125,
});

export const bleedImageLeftNextComponent = css({
  minHeight: 294,
  marginTop: 20,
});
